module.exports = __webpack_public_path__ + "media/assets/images/landing/права-7ac6572ada744b48def888222e833183.png";